import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";

export default function AnnouncementCard({announcement}) {
    return (
        <div className="rounded border bg-gray-700 mr-4 p-1 mb-3">
            <div className="flex justify-left space-x-2 justify-between py-0.5 pr-3">
                <h2 className="text-xl">{announcement.title}</h2>
                <span>{announcement.date}</span>
            </div>
            <span>{announcement.text}</span>
        </div>
    );
}